import { Text } from "@ttc3k/trekker";
import { useOperatorNameByIdQuery } from "gql/generated.ts";
import { getMultilingualString } from "shared/utils";
import { SimpleErrorNotification, SimpleLoader } from "shared/components";
import { Divider } from "styled-system/jsx";

type OperatorMenuProps = {
  operatorEntityId: string;
};

export const OperatorMenu = ({ operatorEntityId }: OperatorMenuProps) => {
  const { data, error, loading } = useOperatorNameByIdQuery({
    variables: { operatorEntityId },
  });

  if (loading) return <SimpleLoader />;

  if (error) return <SimpleErrorNotification />;

  if (!data || !data.operatorById) {
    return null;
  }

  return (
    <>
      <Divider
        orientation={"vertical"}
        thickness={"2px"}
        height={"16px"}
        color={"border.light"}
        pointerEvents="none"
      />
      <Text visual={"smallMedium"} color={"text.dark"}>
        {getMultilingualString(data.operatorById.name)}
      </Text>
    </>
  );
};
